<template>
  <v-row justify="end" class="mr-0">
    <v-dialog persistent v-model="editItemDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{$t(translation+'.edit')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-on:submit.prevent>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.name"
                    :label="$t(translation+'.name')+'*'" required
                    :rules="rules.required_length"
                    autocomplete="off"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.description"
                    :label="$t(translation+'.description')+'*'" required
                    :rules="rules.required_length"
                    autocomplete="off"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.price"
                    :label="$t(translation+'.price')+'*'" required
                    :rules="rules.valid_price"
                    autocomplete="off"
                  />
                </v-col>
                <v-col>
                <v-file-input
                  accept=".jpg,.png,.jpeg"
                  v-model="form.image"
                  :label="$t(translation+'.upload')+'*'" required
                  prepend-icon="mdi-paperclip"
                  :rules="rules.required_image"
                >
                    <template v-slot:selection="{ text }">
                      {{ text }}
                    </template>
                  </v-file-input>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>{{$t('required_fields')}}</small>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text :disabled="loading" @click="closeDialog">{{$t('close')}}</v-btn>
          <v-btn color="blue darken-1" text :loading="loading" @click="edit(api,dataForModal)">
            {{$t('edit')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!---------------------------------- Snackbar  ----------------------------------------->
    <v-snackbar
      v-model="snackbar.show"
      :bottom=true
      :color="snackbar.color"
      :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn dark text @click="snackbar.show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
  import {edit, readCountriesActive} from "../../statics/DataTableFunctions";
  import axios from "axios";

  export default {
    props: {
      editItemDialog: false,
      dataForModal: {},
    },
    name: "EditCategory",
    data() {
      return {
        translation: 'products',
        api: 'products',
        loading: false,
        type: null,
        form: {
          name: '',
          description:'',
          price: '',
          image: null,
        },
        rules: {
          required: [
            v => (v.id != null || v.id != undefined) || this.$t('validation.field'),
          ],
          required_length: [
            v => !!v || this.$t('validation.field'),
            v => v === '' || v.length > 1 || v.price >= 0 || this.$t(this.translation + '.validation_length')
          ],
          valid_price: [
            v => !!v || this.$t('validation.field'),
            v =>  +v >= 0 || this.$t(this.translation + '.valid_price'),
          ],
          required_image: [
            v => {
              if (v) return (this.form.image.name.split('.')[1] === 'jpg' || this.form.image.name.split('.')[1] === 'jepg' || this.form.image.name.split('.')[1] === 'png') || this.$t(this.translation + '.image_validation');
              else return true;
            },
          ],
        },
        snackbar: {
          color: 'success',
          show: false,
          text: '',
          timeout: 3000,
        },
      }
    },
    methods: {
      edit(){
        if (!this.$refs.form.validate()) {
          this.snackbar.color = 'error';
          this.snackbar.text = this.$t('snackbar_required');
          this.snackbar.show = true;
          return;
        }
        let formData = new FormData();
        formData.append("image", this.form.image == null ? null : this.form.image);
        formData.append("price", this.form.price)
        formData.append("description", this.form.description);
        formData.append("name", this.form.name);
        this.loading = true;
        axios.post('api/products/' + this.item.id, formData).then((response) => {
          this.$emit('editEmit', response.data)
          this.closeDialog();
          this.loading = false;
          this.snackbar.color = 'success';
          this.snackbar.text = 'Uspješna izmjena';
          this.snackbar.show = true;
        }).catch(error => {
          if (error.response.status == 401) {
            this.loadingAdd = false
            this.$swal.fire({
              type: 'info',
              title: "Info",
              text: this.$t('validation.session'),
            })
            this.$router.push('/login')
          } else {
            this.loadingAdd = false
            this.$swal.fire({
              type: 'error',
              title: this.$t('validation.error'),
              text: this.$t('validation.error'),
            })
          }
        })
      },
      closeDialog() {
        this.form = {
          name: '',
          description:'',
          price: '',
          image: null
        };
        this.$refs.form.resetValidation()
        this.$emit('close')
      },
    },
    watch: {
      editItemDialog: function (val) {
        if (val) {
          this.form = {
            name: this.dataForModal.name,
            description: this.dataForModal.description,
            price: this.dataForModal.price,
          }
          this.item = this.dataForModal;
        }
      },
    },
    created() {
    }
  }
</script>

<style scoped/>
